// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "rescript/lib/es6/caml.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as InfoTooltip from "../components/InfoTooltip.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as UnitTooltip from "common/src/tft-static/UnitTooltip.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as Caml_splice_call from "rescript/lib/es6/caml_splice_call.js";
import * as Belt_MutableSetString from "rescript/lib/es6/belt_MutableSetString.js";

function Tc2UnitDistribution(Props) {
  var units = Props.units;
  var groupCount = Props.groupCount;
  var unitItemCounts = Props.unitItemCounts;
  var t = Translation.useT(/* Common */0);
  var uniqUnits = Belt_MutableSetString.make(undefined);
  Belt_Array.forEach(units, (function (param) {
          return Belt_MutableSetString.add(uniqUnits, param[0]);
        }));
  var units2 = Belt_Array.slice(Belt_SortArray.stableSortBy(Belt_Array.map(Belt_MutableSetString.toArray(uniqUnits), (function (unitId) {
                  var stats = Belt_Array.keep(units, (function (param) {
                          return param[0] === unitId;
                        }));
                  var s = Belt_Array.reduce(stats, [
                        0,
                        0
                      ], (function (acc, param) {
                          var c = param[2];
                          return [
                                  acc[0] + c | 0,
                                  acc[1] + Global.f(c) * param[3]
                                ];
                        }));
                  return [
                          unitId,
                          s
                        ];
                })), (function (param, param$1) {
              return Caml.caml_int_compare(param$1[1][0], param[1][0]);
            })), 0, 16);
  var places = Belt_Array.map(units2, (function (param) {
          var match = param[1];
          return match[1] / Global.f(match[0]);
        }));
  var maxPlace = Caml_splice_call.spliceApply(Math.max, [places]);
  var minPlace = Caml_splice_call.spliceApply(Math.min, [places]);
  var lowPlace = maxPlace + 0.2;
  var placeRange = lowPlace - minPlace;
  return React.createElement("div", undefined, React.createElement("div", {
                  className: "flex items-center"
                }, React.createElement("div", {
                      className: "text-lg font-montserrat font-medium pr-2"
                    }, t("Units")), React.createElement(InfoTooltip.make, {
                      children: React.createElement("div", {
                            className: "leading-snug"
                          }, "In the center, it shows the unit's use percentage in the team composition and average place when used. For unit item counts and star levels, it shows the percent of total unit games in the team composition at that item count, star level, and average place when given the amount of items or star level.")
                    })), React.createElement("div", {
                  className: "w-full overflow-x-auto sm:overflow-x-visible py-1 max-w-[100vw]"
                }, React.createElement("div", {
                      className: "text-[12px] grid items-center grid-cols-[repeat(4,50px)_58px_208px_repeat(3,50px)] grid-rows-[24px_repeat(16,51px)]"
                    }, React.createElement("div", {
                          className: "text-center"
                        }, "0 " + t("Items")), React.createElement("div", {
                          className: "text-center"
                        }, "1 " + t("Items")), React.createElement("div", {
                          className: "text-center"
                        }, "2 " + t("Items")), React.createElement("div", {
                          className: "text-center"
                        }, "3 " + t("Items")), React.createElement("div", undefined), React.createElement("div", undefined), React.createElement("div", {
                          className: "text-center"
                        }, "★"), React.createElement("div", {
                          className: "text-center"
                        }, "★★"), React.createElement("div", {
                          className: "text-center"
                        }, "★★★"), Belt_Array.mapWithIndex(units2, (function (rowIdx, param) {
                            var match = param[1];
                            var c = match[0];
                            var unitId = param[0];
                            var units$1 = Belt_SortArray.stableSortBy(Belt_Array.keep(units, (function (param) {
                                        return unitId === param[0];
                                      })), (function (param, param$1) {
                                    return Caml.caml_int_compare(param[1], param$1[1]);
                                  }));
                            var pl = match[1] / Global.f(c);
                            var part = Global.f(c) / Global.f(groupCount);
                            return React.createElement(React.Fragment, undefined, Belt_Array.map(Belt_Array.map(Belt_Array.range(0, 3), (function (idx) {
                                                  return Belt_Option.flatMap(unitItemCounts, (function (uic) {
                                                                return Js_dict.get(uic, unitId + "-" + String(idx));
                                                              }));
                                                })), (function (d) {
                                              return React.createElement("div", {
                                                          className: "flex flex-col items-center justify-center px-2 w-full h-full" + (
                                                            rowIdx % 2 === 0 ? " bg-bg2" : ""
                                                          )
                                                        }, React.createElement("div", undefined, d !== undefined ? Global.formatPct(undefined, Global.f(d[0]) / Global.f(c)) : "-"), React.createElement("div", undefined, d !== undefined ? Global.toFixed(undefined, d[1]) : "-"));
                                            })), React.createElement("div", {
                                            className: "h-full w-full flex items-center justify-center pl-[10px]" + (
                                              rowIdx % 2 === 0 ? " bg-bg2" : ""
                                            )
                                          }, React.createElement(UnitTooltip.make, {
                                                unit: unitId,
                                                children: React.createElement(UnitImage.make, {
                                                      unitId: unitId,
                                                      size: 34
                                                    })
                                              })), React.createElement("div", {
                                            className: "w-[208px] flex flex-col justify-center h-full pr-[10px]" + (
                                              rowIdx % 2 === 0 ? " bg-bg2" : ""
                                            )
                                          }, React.createElement("div", {
                                                className: "flex items-center"
                                              }, React.createElement("div", {
                                                    className: "ml-2 mr-[7px] bg-secondary-9 h-3",
                                                    style: Global.s({
                                                          width: (Caml.caml_float_min(1, Global.f(c) / Global.f(groupCount)) * 150).toFixed() + "px"
                                                        })
                                                  }), part >= 0.9995 ? "100%" : Global.formatPct(undefined, part) + "%"), React.createElement("div", {
                                                className: "flex items-center mt-[1px]"
                                              }, React.createElement("div", {
                                                    className: "ml-2 mr-[7px] h-3 bg-primary-11",
                                                    style: Global.s({
                                                          width: ((lowPlace - pl) / placeRange * 150).toFixed() + "px"
                                                        })
                                                  }), Global.toFixed(undefined, pl))), Belt_Array.map(Belt_Array.map(Belt_Array.range(1, 3), (function (idx) {
                                                  return Caml_option.undefined_to_opt(units$1.find(function (param) {
                                                                  return idx === param[1];
                                                                }));
                                                })), (function (d) {
                                              return React.createElement("div", {
                                                          className: "h-full w-full flex flex-col items-center justify-center px-2" + (
                                                            rowIdx % 2 === 0 ? " bg-bg2" : ""
                                                          )
                                                        }, React.createElement("div", undefined, d !== undefined ? Global.formatPct(undefined, Global.f(d[2]) / Global.f(c)) : null), React.createElement("div", undefined, d !== undefined ? Global.toFixed(undefined, d[3]) : null));
                                            })));
                          })))));
}

var make = Tc2UnitDistribution;

export {
  make ,
  
}
/* react Not a pure module */
